import { useMemo } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import "./Boarding.scss";

interface ITutorialElements {
  name: string;
  id: number;
}

export const Boarding = () => {
  const tutorialElements: ITutorialElements[] = useMemo(
    () => [
      {
        name: "Bank City",
        id: 1,
      },
      {
        name: "Bank Name",
        id: 2,
      },
      {
        name: "Bank Address",
        id: 3,
      },
      {
        name: "Your BIC",
        id: 4,
      },
      {
        name: "Your IBAN",
        id: 5,
      },
      {
        name: "Bank Account Owner Name",
        id: 6,
      },
      {
        name: "Bank Postcode",
        id: 7,
      },
      {
        name: "Your City",
        id: 8,
      },
      {
        name: "Your Country",
        id: 9,
      },
      {
        name: "Your Email",
        id: 10,
      },
      {
        name: "Your Fax",
        id: 11,
      },
      {
        name: "Your First Name",
        id: 12,
      },
      {
        name: "Your Last Name",
        id: 13,
      },
      {
        name: "Your Phone",
        id: 14,
      },
      {
        name: "Your Secondary Phone",
        id: 15,
      },
      {
        name: "Your County",
        id: 16,
      },
      {
        name: "Your Address",
        id: 17,
      },
      {
        name: "Your Address (continued)",
        id: 18,
      },
      {
        name: "Your Website",
        id: 19,
      },
      {
        name: "Your Postcode",
        id: 20,
      },
      {
        name: "Payment Method",
        id: 23,
      },
      {
        name: "VAT Number",
        id: 24,
      },
      {
        name: "Company Name",
        id: 25,
      },
      {
        name: "Company Registration Number",
        id: 26,
      },
      {
        name: "Shop Name",
        id: 27,
      },
    ],
    []
  );

  return (
    <main className="boarding-tutorial-container">
      <header>
        <h1>Boarding Tutorial for Mirakl Users</h1>
        <small>
          <a href="/">Back to site</a>
        </small>
      </header>
      <div className="mirakl-video-container">
        <iframe
          title="Mirakl Tutorial"
          src="https://player.vimeo.com/video/672189110?h=819ceff946"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <h2>Fields Explanatory</h2>
      <Accordion allowMultipleExpanded allowZeroExpanded>
        {tutorialElements.flatMap((element) => {
          return (
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>{element.name}</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p>
                  <img
                    src={`/hop-helpers/tooltip-${element.id}.png`}
                    alt={element.name}
                  />
                </p>
              </AccordionItemPanel>
            </AccordionItem>
          );
        })}
      </Accordion>
    </main>
  );
};
